import { UserPendingChangeType } from 'apollo/generated/client-operations';
import { phoneNumberValidation } from 'utils/validation';
import { EnvelopeIcon } from 'components/icons';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import {
  PendingChangeInfoFormData,
  UserPendingChange,
} from 'containers/userPendingChange/steps/types';

export type GetFormInputsArgs = { changeType: UserPendingChangeType };

export const getFormInputs = (
  args: GetFormInputsArgs,
): TypedFormInputs<PendingChangeInfoFormData> => {
  const { changeType: type } = args;
  return {
    currentPhoneNumber: {
      element: FormInputTypes.Field,
      label: 'Old phone number',
      isHidden: type !== UserPendingChangeType.Phone,
      elementProps: {
        fieldType: 'phone',
        showDefaultIcon: true,
        disabled: true,
      },
      validation: { required: true, pattern: phoneNumberValidation },
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
    },
    newPhoneNumber: {
      element: FormInputTypes.Field,
      label: 'New phone number',
      isHidden: type !== UserPendingChangeType.Phone,
      elementProps: {
        fieldType: 'phone',
        showDefaultIcon: true,
        disabled: true,
      },
      validation: { required: true, pattern: phoneNumberValidation },
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
    },
    currentEmail: {
      element: FormInputTypes.Field,
      label: 'Old email address',
      isHidden: type !== UserPendingChangeType.Email,
      elementProps: {
        disabled: true,
        icon: EnvelopeIcon,
      },
      // Both fields are read-only on this confirmation step; RHF still runs
      // validate on disabled fields, so a legacy invalid email would block
      // confirming the change. Format was already enforced upstream (and again
      // server-side on confirm), so only keep the required check here.
      validation: { required: true },
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
    },
    newEmail: {
      element: FormInputTypes.Field,
      label: 'New email address',
      isHidden: type !== UserPendingChangeType.Email,
      elementProps: {
        icon: EnvelopeIcon,
        disabled: true,
      },
      validation: { required: true },
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
    },
  };
};

export const getDefaultValues = (
  changeType: UserPendingChangeType,
  change: UserPendingChange,
): PendingChangeInfoFormData => {
  return changeType === UserPendingChangeType.Phone
    ? {
        currentPhoneNumber: change.currentValue ?? '',
        newPhoneNumber: change.newValue ?? '',
        currentEmail: '',
        newEmail: '',
      }
    : {
        currentPhoneNumber: '',
        newPhoneNumber: '',
        currentEmail: change.currentValue ?? '',
        newEmail: change.newValue ?? '',
      };
};
